import { render, staticRenderFns } from "./PlateHoverCard.vue?vue&type=template&id=f3217fb2&scoped=true"
import script from "./PlateHoverCard.vue?vue&type=script&lang=js"
export * from "./PlateHoverCard.vue?vue&type=script&lang=js"
import style0 from "./PlateHoverCard.vue?vue&type=style&index=0&id=f3217fb2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3217fb2",
  null
  
)

export default component.exports